const MODULE_NAME = 'LoadingModule';

const SET_LOADING_STATE = `${MODULE_NAME}/SET_LOADING_STATE`;

export default SET_LOADING_STATE;
